import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { DEFAULT_HEADER_HEIGHT } from '@core/components/header/header.model';
import { AccountService } from '@core/services/account.service';
import { NotificationsCenterService } from '@core/services/notifications-center.service';
import { UnsubscribeService } from '@core/services/unsubscribe.service';
import { combineLatest } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { AnalyticsService } from './modules/analytics/analytics.service';

@Component({
  selector: 'gcc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public defaultHeaderHeight = DEFAULT_HEADER_HEIGHT;
  public notificationsAndHeaderHeight = DEFAULT_HEADER_HEIGHT;
  public isShowNotifications = false;

  private daWebChatWidget: HTMLElement | null;

  constructor(
    private accountService: AccountService,
    private router: Router,
    private analyticsService: AnalyticsService,
    private notificationCenterService: NotificationsCenterService,
    private unsubscribe$: UnsubscribeService
  ) {}

  public ngOnInit() {
    this.daWebChatWidget = document.getElementById('da-webchat-widget');

    combineLatest([
      this.router.events.pipe(filter(event => event instanceof NavigationEnd)),
      this.accountService.account$
    ])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([event, account]) => {
        this.analyticsService.trackPageInfo((event as NavigationEnd).url, account?.username);
        this.onShowDA(event as NavigationEnd);
      });

    this.notificationCenterService.notificationsAndHeaderHeight$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(height => {
        this.notificationsAndHeaderHeight = height;
      });

    this.notificationCenterService.isShowNotifications$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(isShowNotifications => (this.isShowNotifications = isShowNotifications));
  }

  public onScrolls(): void {
    if (document.getElementsByTagName('bs-dropdown-container')?.length) {
      document.body.click();
    }
  }

  private onShowDA(event: RouterEvent): void {
    const isShowChat =
      event.url === '/' ||
      event.url.startsWith('/?') ||
      event.url.indexOf('/journey/') === 0 ||
      event.url.indexOf('/about') === 0;

    this.daWebChatWidget.style.display = isShowChat ? 'block' : 'none';
  }
}
